import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import QuoteCarouselComponent from '../HomePage/QuoteCarousel/QuoteCarouselComponent';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/ComboInsurance/keyPointVerticalNumericData.json';

import PartnerBrandsComponent from '../HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/ComboInsurance/partnerBrandsData.json';

import CustomerReviewsComponent from '../HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/ComboInsurance/customerReviewsData.json';

import ScrollingCardsComponent from '../HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsData from '../../json/components/HomePages/ComboInsurance/scrollingCardsData.json';

import SectionStepsComponent from '../../components/HomePage/SectionSteps/SectionStepsComponent';
import SectionStepsMobileComponent from '../../components/HomePage/SectionSteps/SectionStepsMobileComponent';
import sectionStepsData from '../../json/components/HomePages/ComboInsurance/sectionStepsData.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/ComboInsurance/fourBlogCardsData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/ComboInsurance/accordionFAQData.json';

import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';
import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';

function ComboInsurancePage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/online-insurance-quote/step1';

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestComboInsuranceQuotes_CrossSell"
        fallbackKey="latestComboInsuranceQuotes"
        navigateTo="/online-insurance-quote/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalNumericComponent
            data={keyPointVerticalNumericData}
          />
        ) : (
          <KeyPointVerticalNumericFourMobileComponent
            data={keyPointVerticalNumericData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoTickle'}
            title={'Combine your car and home cover & save'}
            color={'blue'}
            buttonText={'Compare quotes'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoTickle'}
            title={'Combine your car and home cover & save'}
            color={'blue'}
            buttonText={'Compare quotes'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SectionStepsComponent data={sectionStepsData} />
        ) : (
          <SectionStepsMobileComponent data={sectionStepsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent data={fourBlogCardsData} tag="insurance" />
        ) : (
          <FourBlogCardsMobileComponent
            data={fourBlogCardsData}
            tag="insurance"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default ComboInsurancePage;
